export const production = import.meta.env.PROD;

export const serverUrl = '';

export const digitalAccountApiUrl = '/api-web/v1/pub';

export const ENV = {
  apiUrl: '',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  isLocal: import.meta.env.VITE_LOCAL === 'true',
};

// Placeholder replaced at container startup by docker/init.sh

export const fileBaseURL = ENV.isLocal ? 'https://dev-uploader.yelo.az' : 'UPLOADER_URL';
